import { HiOutlineMoon, HiOutlineSun } from "react-icons/hi2";
import { Switch } from "@/components/ui/switch";
import { useUiStore } from "@/stores/UiStore";

function DarkModeToggle() {
  const darkMode = useUiStore((state) => state.darkMode);
  const toggleDarkMode = useUiStore((state) => state.toggleDarkMode);

  return (
    <div className="flex gap-4 self-center">
      <HiOutlineMoon />
      <Switch checked={darkMode} onClick={toggleDarkMode} />
      <HiOutlineSun />
    </div>
  );
}

export default DarkModeToggle;
